import http from '@/plugins/axios/axios';

export default class EmpresaService {

    listarEstados() {        
        return http.get('/api/empresa/listar-estados');
    }

    listarCidades(idEstado) {       
        return http.get('/api/empresa/listar-cidades/'+idEstado);
    }

    listar() {       
        return http.get('/api/adm/empresa/listar');
    } 

    buscar(requisicao) {       
        return http.post('/api/adm/empresa/buscar', requisicao);
    }

    /* Revendedor */
    salvar(requisicao) {       
        return http.post('/api/adm/empresa/revenda-salvar', requisicao);
    }

    /* Revendedor */
    revendaSalvar(requisicao) {       
        return http.post('/api/adm/empresa/revenda-salvar', requisicao);
    }

    /* Revendedor */
    trocarPlano(requisicao) {
        return http.post('/api/adm/empresa/revenda-trocar-plano', requisicao);
    }
    
    /* Revendedor */
    editarStatus(requisicao) {
        return http.post('/api/adm/empresa/revenda-editar-status', requisicao);
    }    
}